"use client";

import { motion } from "framer-motion";
import NextLink from "components/parts/NextLink";

export const CustomCardFadeIn = ({
  children,
  href,
  id
}: {
  children: React.ReactNode;
  href: string;
  id: string;
}) => {
  return (
    <motion.div
      className="mobile-landscape:p-12 small-desktop:p-13 absolute inset-0 flex cursor-pointer flex-col gap-6.5 py-10 pr-2.5 pl-6 text-white"
      initial="hidden"
      role="link"
      tabIndex={0}
      transition={{
        duration: 0.7,
        delay: 0.2,
        cubic: [0.25, 0.46, 0.45, 0.94]
      }}
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: -20 }
      }}
      viewport={{ once: true }}
      whileInView="visible"
    >
      <NextLink
        className="absolute inset-0 z-1 !text-white"
        href={href}
        id={`${id}-div`}
      >
        <span className="sr-only">Card Link</span>
      </NextLink>
      {children}
    </motion.div>
  );
};
